import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon",
  style: {"width":"1em","height":"1em","vertical-align":"middle","fill":"currentColor","overflow":"hidden"},
  viewBox: "0 0 1024 1024"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M852.728 392.447c104.27 66.027 104.213 173.113 0 239.103l-570.84 361.47c-104.27 66.026-188.797 23.034-188.797-95.883V126.86c0-118.98 84.584-161.873 188.798-95.882l570.839 361.47Z" }, null, -1)
  ]))]))
}
export default { render: render }